import {
  SET_MA_PEOPLE_BAR,
  SET_MA_PEOPLE_USERS,
  SET_MA_PEOPLE_USERS_SORT,
  SET_MA_PEOPLE_USERS_PAGE,
  SET_MA_PEOPLE_USERS_PER_PAGE,
  SET_MA_PEOPLE_LIST,
  SET_MA_PEOPLE_LIST_PAGE,
  SET_MA_PEOPLE_LIST_PER_PAGE,
  SET_MA_PEOPLE_LIST_SORT,
  SET_MA_PEOPLE_ADD_LIST_USERS,
  SET_MA_PROFILE,
  SET_UPDATE_MA_PROFILE_ERRORS,
  SET_MA_PROFILE_USERS_ROLE,
  SET_MA_DASHBOARD,
  SET_MA_EVENTS,
  SET_MA_EVENTS_BAR,
  SET_MA_EVENTS_PAGE,
  SET_MA_EVENTS_PER_PAGE,
  SET_MA_EVENTS_STATUS,
  SET_MA_PEOPLE_ORGANISATIONS_SORT,
  SET_MA_PEOPLE_ORGANISATIONS,
  SET_MA_PEOPLE_ORGANISATIONS_PAGE,
  SET_MA_PEOPLE_ORGANISATIONS_PER_PAGE,
  SET_MA_PROFILE_UPCOMING_EVENTS,
  SET_MA_COURSES,
  SET_MA_COURSES_PAGES,
  SET_MA_COURSES_PAGE,
  SET_MA_COURSES_PER_PAGE,
  SET_MA_COURSES_BAR,
  SET_MA_ASSESSORS,
  SET_MA_PEOPLE_MEMBERS,
  SET_MA_PEOPLE_MEMBERS_SORT,
  SET_MA_PEOPLE_MEMBERS_PAGE,
  SET_MA_PEOPLE_MEMBERS_PER_PAGE,
  SET_MA_REPORT_ERRORS,
  SET_MA_REPORT_LIST,
  SET_MA_REPORT,
  SET_MA_UPDATE_REPORT,
  SET_MA_PEOPLE_YC,
  SET_MA_PEOPLE_YC_SORT,
  SET_MA_PEOPLE_YC_PAGE,
  SET_MA_PEOPLE_YC_PER_PAGE,
  SET_MA_PEOPLE_LIST_FILTERS,
  SET_MA_PEOPLE_MEMBERS_FILTERS,
  SET_MA_PEOPLE_YC_FILTERS,
  SET_MA_PEOPLE_USERS_FILTERS,
  SET_MA_CIS,
  SET_MA_CIS_PAGES,
  SET_MA_CIS_PAGE,
  SET_MA_CIS_PER_PAGE,
  SET_MA_CIS_SORT,
  SET_MA_CIS_FILTERS,
  REMOVE_MA_CIS_FILTERS,
  SET_MA_CIS_PROFILE,
  SET_MA_CIS_CREATE_ERRORS,
  SET_MA_CIS_EDIT_ERRORS,
  SET_MA_CIS_BAR,
  SET_MA_CIS_TOTAL_ITEMS,
  SET_MA_CIS_CREATED,
  SET_MA_CIS_DETAILS,
  SET_MA_CLAIMED_CERTIFICATES,
  REMOVE_MA_CIS_DETAILS,
  SET_MA_CLAIMED_CERTIFICATES_FILTERS,
  SET_MA_CLAIMED_CERTIFICATES_PAGE,
  SET_MA_CLAIMED_CERTIFICATES_PER_PAGE,
  SET_MA_CLAIMED_CERTIFICATES_SORT,
  SET_MA_CIS_ALLOWED_CB_LEVEL_DOMAINS,
  SET_MA_REPORT_INFO,
  SET_MA_TRAININGS,
  SET_MA_TRAININGS_PAGES,
  SET_MA_TRAININGS_PAGE,
  SET_MA_TRAININGS_PER_PAGE,
  SET_MA_TRAININGS_TOTAL_ITEMS,
  SET_MA_TRAININGS_SORT,
  SET_MA_TRAININGS_FILTERS,
  REMOVE_MA_TRAININGS_FILTERS,
  SET_MA_TRAININGS_PROFILE,
  SET_MA_TRAININGS_CREATE_ERRORS,
  SET_MA_TRAININGS_EDIT_ERRORS,
  SET_MA_TRAININGS_IMPORT_ERRORS,
  SET_MA_CPD_DIPLOMAS,
  SET_MA_CPD_DIPLOMAS_PAGE,
  SET_MA_CPD_DIPLOMAS_PER_PAGE,
  SET_MA_CPD_DIPLOMAS_SORT,
  SET_MA_CPD_DIPLOMAS_FILTERS,
  REMOVE_MA_CPD_DIPLOMAS_FILTERS,
  SET_MA_COMPETENCIES,
  SET_MA_COMPETENCIES_PAGE,
  SET_MA_COMPETENCIES_PER_PAGE,
  SET_MA_COMPETENCIES_SORT,
  SET_MA_COMPETENCIES_FILTERS,
  REMOVE_MA_COMPETENCIES_FILTERS,
  SET_MA_CPD_COURSES,
  SET_MA_CPD_COURSES_PAGE,
  SET_MA_CPD_COURSES_PER_PAGE,
  SET_MA_CPD_COURSES_SORT,
  SET_MA_CPD_COURSES_FILTERS,
  REMOVE_MA_CPD_COURSES_FILTERS,
} from '../constants';

const initialState = {
  profile: {
    data: null,
    usersRole: {},
    errors: {},
    upcomingEvents: [],
  },
  people: {
    users: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
      filters: null,
    },
    organisations: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
      filters: null,
    },
    list: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
      filters: null,
      localMemberAssociation: 0,
    },
    members: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
      filters: null,
    },
    yc: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
      filters: null,
    },
    bar: {
      users: 0,
      organisations: 0,
      list: 0,
      members: 0,
      youngcrew: 0,
    },
    add: {
      data: [],
    },
  },
  dashboard: {},
  events: {
    list: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      status: 'ongoing',
    },
    bar: {
      ongoing: 0,
      completed: 0,
      cancelled: 0,
      duplicate: 0,
    },
  },
  courses: {
    unassigned: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
    },
    assigned: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
    },
    accepted: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
    },
    canceled: {
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      sort: null,
    },
    bar: {
      unassigned: 0,
      assigned: 0,
      accepted: 0,
      canceled: 0,
    },
  },
  cis: {
    allowedCbLevelDomains: [],
    certificates: {
      filters: {},
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      totalItems: 0,
      sort: 'createdAt.desc',
      profile: {},
      createErrors: {},
      editErrors: {},
    },
    signatures: {
      filters: {},
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      totalItems: 0,
      sort: 'dateFrom.desc',
      profile: {},
      createErrors: {},
      editErrors: {},
    },
    certificateHolders: {
      filters: {},
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      totalItems: 0,
      sort: 'createdAt.desc',
      profile: {},
      created: {},
      createErrors: {},
      editErrors: {},
    },
    forecasts: {
      filters: {},
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      totalItems: 0,
      sort: 'year.desc',
      profile: {},
      createErrors: {},
      editErrors: {},
    },
    certificationBodies: {
      details: {},
      editErrors: {},
    },
    reports: {
      filters: {},
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      totalItems: 0,
      sort: 'year.desc',
      details: {
        certificationBody: {
          name: '',
          cbHeadName: '',
          cbHeadEmail: '',
          cbHeadTelephone: '',
          country: {
            name: '',
          },
          lcAgreementSignedAt: '',
          lcValidationSignedAt: '',
          deltaAgreementSignedAt: '',
          iso9001AccreditationSignedAt: '',
          iso17024AccreditationSignedAt: '',
          memberAssociation: {
            name: '',
          },
          levels: [
            {
              id: 0,
              name: '',
              domains: [
                {
                  id: 0,
                  name: '',
                },
              ],
            },
          ],
        },
      },
      profile: {},
    },
    unknownImports: {
      filters: {},
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      totalItems: 0,
      sort: 'lastName.desc',
      profile: {},
      createErrors: {},
      editErrors: {},
      certificationBodyLevelDomains: {},
    },
    changeRequests: {
      filters: {},
      items: [],
      page: 1,
      pages: 1,
      perPage: 10,
      totalItems: 0,
      sort: 'createdAt.desc',
      profile: {},
      details: {},
      createErrors: {},
      editErrors: {},
    },
    bar: {
      certificateHolders: 0,
      certificates: 0,
    },
  },
  claimedCertificates: {
    filters: {},
    items: [],
    page: 1,
    pages: 1,
    perPage: 10,
    totalItems: 0,
    sort: 'createdAt.desc',
  },
  trainings: {
    filters: {},
    items: [],
    page: 1,
    pages: 1,
    perPage: 10,
    totalItems: 0,
    sort: 'createdAt.desc',
    profile: {},
    createErrors: {},
    editErrors: {},
    importErrors: [],
  },
  diplomas: {
    filters: {},
    items: [],
    page: 1,
    pages: 1,
    perPage: 10,
    totalItems: 0,
    sort: 'createdAt.desc',
  },
  competencies: {
    filters: {},
    items: [],
    page: 1,
    pages: 1,
    perPage: 10,
    totalItems: 0,
    sort: 'name.asc',
  },
  cpdCourses: {
    filters: {},
    items: [],
    page: 1,
    pages: 1,
    perPage: 10,
    totalItems: 0,
    sort: 'name.asc',
  },
  reports: [],
  report: {},
  reportName: {},
  updateReport: {},
  updateReportName: {},
  reportErrors: {},
  assessors: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MA_PROFILE:
      return { ...state, profile: { ...state.profile, data: action.payload } };
    case SET_MA_PROFILE_USERS_ROLE:
      return { ...state, profile: { ...state.profile, usersRole: action.payload } };
    case SET_UPDATE_MA_PROFILE_ERRORS:
      return { ...state, profile: { ...state.profile, errors: action.payload } };
    case SET_MA_PROFILE_UPCOMING_EVENTS:
      return { ...state, profile: { ...state.profile, upcomingEvents: action.payload } };
    case SET_MA_PEOPLE_BAR:
      return { ...state, people: { ...state.people, bar: action.payload } };
    case SET_MA_PEOPLE_USERS:
      return {
        ...state,
        people: { ...state.people, users: { ...state.people.users, ...action.payload } },
      };
    case SET_MA_CLAIMED_CERTIFICATES:
      return {
        ...state,
        claimedCertificates: {
          ...state.claimedCertificates,
          ...action.payload,
        },
      };
    case SET_MA_CLAIMED_CERTIFICATES_FILTERS:
      return {
        ...state,
        claimedCertificates: {
          ...state.claimedCertificates,
          filters: {
            ...state.claimedCertificates.filters,
            [action.payload.name]: action.payload.value,
          },
        },
      };
    case SET_MA_CLAIMED_CERTIFICATES_PAGE:
      return {
        ...state,
        claimedCertificates: {
          ...state.claimedCertificates,
          page: action.payload,
        },
      };
    case SET_MA_CLAIMED_CERTIFICATES_PER_PAGE:
      return {
        ...state,
        claimedCertificates: {
          ...state.claimedCertificates,
          perPage: action.payload,
        },
      };
    case SET_MA_CLAIMED_CERTIFICATES_SORT:
      return {
        ...state,
        claimedCertificates: {
          ...state.claimedCertificates,
          sort: action.payload,
        },
      };
    case SET_MA_PEOPLE_USERS_SORT:
      return {
        ...state,
        people: { ...state.people, users: { ...state.people.users, sort: action.payload } },
      };
    case SET_MA_PEOPLE_USERS_PAGE:
      return {
        ...state,
        people: { ...state.people, users: { ...state.people.users, page: action.payload } },
      };
    case SET_MA_PEOPLE_USERS_PER_PAGE:
      return {
        ...state,
        people: { ...state.people, users: { ...state.people.users, perPage: action.payload } },
      };
    case SET_MA_PEOPLE_USERS_FILTERS:
      return {
        ...state,
        people: { ...state.people, users: { ...state.people.users, filters: action.payload } },
      };
    case SET_MA_PEOPLE_LIST:
      return {
        ...state,
        people: { ...state.people, list: { ...state.people.list, ...action.payload } },
      };
    case SET_MA_PEOPLE_LIST_SORT:
      return {
        ...state,
        people: { ...state.people, list: { ...state.people.list, sort: action.payload } },
      };
    case SET_MA_PEOPLE_LIST_PAGE:
      return {
        ...state,
        people: { ...state.people, list: { ...state.people.list, page: action.payload } },
      };
    case SET_MA_PEOPLE_LIST_PER_PAGE:
      return {
        ...state,
        people: { ...state.people, list: { ...state.people.list, perPage: action.payload } },
      };
    case SET_MA_PEOPLE_LIST_FILTERS:
      return {
        ...state,
        people: { ...state.people, list: { ...state.people.list, filters: action.payload } },
      };
    case SET_MA_PEOPLE_ADD_LIST_USERS:
      return {
        ...state,
        people: { ...state.people, add: { ...state.people.add, data: action.payload } },
      };
    case SET_MA_PEOPLE_MEMBERS:
      return {
        ...state,
        people: { ...state.people, members: { ...state.people.members, ...action.payload } },
      };
    case SET_MA_PEOPLE_MEMBERS_SORT:
      return {
        ...state,
        people: { ...state.people, members: { ...state.people.members, sort: action.payload } },
      };
    case SET_MA_PEOPLE_MEMBERS_PAGE:
      return {
        ...state,
        people: { ...state.people, members: { ...state.people.members, page: action.payload } },
      };
    case SET_MA_PEOPLE_MEMBERS_PER_PAGE:
      return {
        ...state,
        people: { ...state.people, members: { ...state.people.members, perPage: action.payload } },
      };
    case SET_MA_PEOPLE_MEMBERS_FILTERS:
      return {
        ...state,
        people: { ...state.people, members: { ...state.people.members, filters: action.payload } },
      };
    case SET_MA_DASHBOARD:
      return {
        ...state,
        dashboard: action.payload,
      };
    case SET_MA_EVENTS:
      return {
        ...state,
        events: {
          ...state.events,
          list: {
            ...state.events.list,
            ...action.payload,
          },
        },
      };
    case SET_MA_EVENTS_BAR:
      return {
        ...state,
        events: {
          ...state.events,
          bar: action.payload,
        },
      };
    case SET_MA_EVENTS_PAGE:
      return {
        ...state,
        events: { ...state.events, list: { ...state.events.list, page: action.payload } },
      };
    case SET_MA_EVENTS_PER_PAGE:
      return {
        ...state,
        events: { ...state.events, list: { ...state.events.list, perPage: action.payload } },
      };
    case SET_MA_EVENTS_STATUS:
      return {
        ...state,
        events: {
          ...state.events,
          list: {
            ...state.events.list,
            page: state.events.list.status !== action.payload ? 1 : state.events.list.page,
            status: action.payload,
          },
        },
      };
    case SET_MA_PEOPLE_ORGANISATIONS:
      return {
        ...state,
        people: {
          ...state.people,
          organisations: { ...state.people.organisations, ...action.payload },
        },
      };
    case SET_MA_PEOPLE_ORGANISATIONS_SORT:
      return {
        ...state,
        people: {
          ...state.people,
          organisations: { ...state.people.organisations, sort: action.payload },
        },
      };
    case SET_MA_PEOPLE_ORGANISATIONS_PAGE:
      return {
        ...state,
        people: {
          ...state.people,
          organisations: { ...state.people.organisations, page: action.payload },
        },
      };
    case SET_MA_PEOPLE_ORGANISATIONS_PER_PAGE:
      return {
        ...state,
        people: {
          ...state.people,
          organisations: { ...state.people.organisations, perPage: action.payload },
        },
      };
    case SET_MA_COURSES:
      return {
        ...state,
        courses: {
          ...state.courses,
          [action.listType]: {
            ...state.courses[action.listType],
            items: action.payload,
          },
        },
      };
    case SET_MA_COURSES_PAGES:
      return {
        ...state,
        courses: {
          ...state.courses,
          [action.listType]: {
            ...state.courses[action.listType],
            pages: action.payload,
          },
        },
      };
    case SET_MA_COURSES_PAGE:
      return {
        ...state,
        courses: {
          ...state.courses,
          [action.listType]: {
            ...state.courses[action.listType],
            page: action.payload,
          },
        },
      };
    case SET_MA_COURSES_PER_PAGE:
      return {
        ...state,
        courses: {
          ...state.courses,
          [action.listType]: {
            ...state.courses[action.listType],
            perPage: action.payload,
          },
        },
      };
    case SET_MA_COURSES_BAR:
      return {
        ...state,
        courses: {
          ...state.courses,
          bar: action.payload,
        },
      };
    case SET_MA_ASSESSORS:
      return {
        ...state,
        assessors: action.payload,
      };
    case SET_MA_REPORT_ERRORS:
      return { ...state, reportErrors: action.payload };
    case SET_MA_REPORT_LIST:
      return {
        ...state,
        reports: action.payload,
      };
    case SET_MA_REPORT:
      return {
        ...state,
        report: action.payload.report,
        reportName: action.payload.name,
      };
    case SET_MA_UPDATE_REPORT:
      return {
        ...state,
        updateReport: action.payload.report,
        updateReportName: action.payload.name,
      };
    case SET_MA_REPORT_INFO:
      return {
        ...state,
        reportInfo: action.payload,
      };
    case SET_MA_PEOPLE_YC:
      return {
        ...state,
        people: { ...state.people, yc: { ...state.people.yc, ...action.payload } },
      };
    case SET_MA_PEOPLE_YC_SORT:
      return {
        ...state,
        people: { ...state.people, yc: { ...state.people.yc, sort: action.payload } },
      };
    case SET_MA_PEOPLE_YC_PAGE:
      return {
        ...state,
        people: { ...state.people, yc: { ...state.people.yc, page: action.payload } },
      };
    case SET_MA_PEOPLE_YC_PER_PAGE:
      return {
        ...state,
        people: { ...state.people, yc: { ...state.people.yc, perPage: action.payload } },
      };
    case SET_MA_PEOPLE_YC_FILTERS:
      return {
        ...state,
        people: { ...state.people, yc: { ...state.people.yc, filters: action.payload } },
      };
    case SET_MA_CIS:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            items: action.payload,
          },
        },
      };
    case SET_MA_CIS_PAGES:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            pages: action.payload,
          },
        },
      };
    case SET_MA_CIS_PAGE:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            page: action.payload,
          },
        },
      };
    case SET_MA_CIS_PER_PAGE:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            perPage: action.payload,
          },
        },
      };
    case SET_MA_CIS_TOTAL_ITEMS:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: { ...state.cis[action.cisType], totalItems: action.payload },
        },
      };
    case SET_MA_CIS_SORT:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            sort: action.payload,
          },
        },
      };
    case SET_MA_CIS_FILTERS:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            filters: {
              ...state.cis[action.cisType].filters,
              [action.payload.name]: action.payload.value,
            },
          },
        },
      };
    case REMOVE_MA_CIS_FILTERS:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            filters: {},
          },
        },
      };
    case SET_MA_CIS_PROFILE:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            profile: action.payload,
          },
        },
      };
    case SET_MA_CIS_CREATED:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            created: action.payload,
          },
        },
      };
    case SET_MA_CIS_CREATE_ERRORS:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            createErrors: action.payload,
          },
        },
      };
    case SET_MA_CIS_EDIT_ERRORS:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            editErrors: action.payload,
          },
        },
      };
    case SET_MA_CIS_BAR:
      return {
        ...state,
        cis: {
          ...state.cis,
          bar: action.payload,
        },
      };
    case SET_MA_CIS_DETAILS:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            details: action.payload,
          },
        },
      };
    case REMOVE_MA_CIS_DETAILS:
      return {
        ...state,
        cis: {
          ...state.cis,
          [action.cisType]: {
            ...state.cis[action.cisType],
            details: initialState.cis[action.cisType].details,
          },
        },
      };
    case SET_MA_CIS_ALLOWED_CB_LEVEL_DOMAINS:
      return {
        ...state,
        cis: {
          ...state.cis,
          allowedCbLevelDomains: action.payload,
        },
      };
    case SET_MA_TRAININGS:
      return { ...state, trainings: { ...state.trainings, items: action.payload } };
    case SET_MA_TRAININGS_PAGES:
      return { ...state, trainings: { ...state.trainings, pages: action.payload } };
    case SET_MA_TRAININGS_PAGE:
      return { ...state, trainings: { ...state.trainings, page: action.payload } };
    case SET_MA_TRAININGS_PER_PAGE:
      return { ...state, trainings: { ...state.trainings, perPage: action.payload } };
    case SET_MA_TRAININGS_TOTAL_ITEMS:
      return { ...state, trainings: { ...state.trainings, totalItems: action.payload } };
    case SET_MA_TRAININGS_SORT:
      return { ...state, trainings: { ...state.trainings, sort: action.payload } };
    case SET_MA_TRAININGS_FILTERS:
      return {
        ...state,
        trainings: {
          ...state.trainings,
          filters: { ...state.trainings.filters, [action.payload.name]: action.payload.value },
        },
      };
    case REMOVE_MA_TRAININGS_FILTERS:
      return { ...state, trainings: { ...state.trainings, filters: {} } };
    case SET_MA_TRAININGS_PROFILE:
      return { ...state, trainings: { ...state.trainings, profile: action.payload } };
    case SET_MA_TRAININGS_CREATE_ERRORS:
      return { ...state, trainings: { ...state.trainings, createErrors: action.payload } };
    case SET_MA_TRAININGS_EDIT_ERRORS:
      return { ...state, trainings: { ...state.trainings, editErrors: action.payload } };
    case SET_MA_TRAININGS_IMPORT_ERRORS:
      return { ...state, trainings: { ...state.trainings, importErrors: action.payload } };
    case SET_MA_CPD_DIPLOMAS:
      return { ...state, diplomas: { ...state.diplomas, ...action.payload } };
    case SET_MA_CPD_DIPLOMAS_PAGE:
      return { ...state, diplomas: { ...state.diplomas, page: action.payload } };
    case SET_MA_CPD_DIPLOMAS_PER_PAGE:
      return { ...state, diplomas: { ...state.diplomas, perPage: action.payload } };
    case SET_MA_CPD_DIPLOMAS_SORT:
      return { ...state, diplomas: { ...state.diplomas, sort: action.payload } };
    case SET_MA_CPD_DIPLOMAS_FILTERS:
      return {
        ...state,
        diplomas: {
          ...state.diplomas,
          filters: { ...state.diplomas.filters, [action.payload.name]: action.payload.value },
        },
      };
    case REMOVE_MA_CPD_DIPLOMAS_FILTERS:
      return { ...state, diplomas: { ...state.diplomas, filters: {} } };
    case SET_MA_COMPETENCIES:
      return { ...state, competencies: { ...state.competencies, ...action.payload } };
    case SET_MA_COMPETENCIES_PAGE:
      return { ...state, competencies: { ...state.competencies, page: action.payload } };
    case SET_MA_COMPETENCIES_PER_PAGE:
      return { ...state, competencies: { ...state.competencies, perPage: action.payload } };
    case SET_MA_COMPETENCIES_SORT:
      return { ...state, competencies: { ...state.competencies, sort: action.payload } };
    case SET_MA_COMPETENCIES_FILTERS:
      return {
        ...state,
        competencies: {
          ...state.competencies,
          filters: { ...state.competencies.filters, [action.payload.name]: action.payload.value },
        },
      };
    case REMOVE_MA_COMPETENCIES_FILTERS:
      return { ...state, competencies: { ...state.competencies, filters: {} } };
    case SET_MA_CPD_COURSES:
      return { ...state, cpdCourses: { ...state.cpdCourses, ...action.payload } };
    case SET_MA_CPD_COURSES_PAGE:
      return { ...state, cpdCourses: { ...state.cpdCourses, page: action.payload } };
    case SET_MA_CPD_COURSES_PER_PAGE:
      return { ...state, cpdCourses: { ...state.cpdCourses, perPage: action.payload } };
    case SET_MA_CPD_COURSES_SORT:
      return { ...state, cpdCourses: { ...state.cpdCourses, sort: action.payload } };
    case SET_MA_CPD_COURSES_FILTERS:
      return {
        ...state,
        cpdCourses: {
          ...state.cpdCourses,
          filters: { ...state.cpdCourses.filters, [action.payload.name]: action.payload.value },
        },
      };
    case REMOVE_MA_CPD_COURSES_FILTERS:
      return { ...state, cpdCourses: { ...state.cpdCourses, filters: {} } };
    default:
      return state;
  }
};
